import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAdV-bwpwM2G0DwBZ7sYrmYq-e9K5WsEtU",
  authDomain: "genexasourceproject.firebaseapp.com",
  projectId: "genexasourceproject",
  storageBucket: "genexasourceproject.appspot.com",
  messagingSenderId: "834551432924",
  appId: "1:834551432924:web:383cf63c3b735e53c05619",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
